export const isMobile = (): boolean => {
    if (!navigator || !navigator.userAgent) return false;

    const ua = navigator.userAgent;
    return /Mobi/.test(ua);
}

export const isTablet = (): boolean => {
    if (!navigator || !navigator.userAgent) return false;

    const ua = navigator.userAgent;
    return /Tablet/.test(ua);
}

export const isDesktop = (): boolean => {
    return !isMobile() && !isTablet();
}

